// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1GzuO","calendarButtons":"ClockData_calendarButtons__vU4-N"};